// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2wYwr","balanceDisclaimer":"posDashboard_balanceDisclaimer__5tRsF"};